import { render, staticRenderFns } from "./SimilarProducts.vue?vue&type=template&id=2d8402f0&"
import script from "./SimilarProducts.vue?vue&type=script&lang=js&"
export * from "./SimilarProducts.vue?vue&type=script&lang=js&"
import style0 from "./SimilarProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports